import React from 'react';
const Footer = () => {
  return <footer className="bg-[#F0F4F8] border-t border-[#E2E8F0]" data-id="element-412">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6" data-id="element-413">
        <div className="flex flex-col md:flex-row items-center justify-between space-y-4 md:space-y-0" data-id="element-414">
          <div className="flex items-center space-x-3" data-id="element-415">
            <img src="https://cdn.magicpatterns.com/uploads/ca1Sgnsnn3Rh2VWwbyfsy6/Paysys_Logo.png" alt="Paysys" className="h-9" data-id="element-416" />
            <span className="text-sm text-[#0D3B66]/70 font-medium" data-id="element-417">
              Powered by Paysys
            </span>
          </div>

          <div className="flex flex-col md:flex-row items-center space-y-2 md:space-y-0 md:space-x-6 text-sm text-[#0D3B66]/60" data-id="element-418">
            <a href="#" className="hover:text-[#0D3B66] transition-colors" data-id="element-419">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-[#0D3B66] transition-colors" data-id="element-420">
              Terms of Service
            </a>
            <a href="#" className="hover:text-[#0D3B66] transition-colors" data-id="element-421">
              Support
            </a>
          </div>

          <p className="text-sm text-[#0D3B66]/50" data-id="element-422">
            © {new Date().getFullYear()} Paysys. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
};
export default Footer;